import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const dismissed = localStorage.getItem('announcementDismissed');
    if (dismissed) {
      setIsVisible(false);
    }
  }, []);
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('announcementDismissed', 'true');
  };
  if (!isVisible) return null;
  return <div className="bg-midnight-elevated border-b border-white/5 py-2 px-4 relative z-50 flex items-center justify-center" data-id="element-37">
      <Link to="/astrology" className="text-gold hover:text-gold-light text-xs md:text-sm font-medium tracking-wide flex items-center gap-2 transition-colors" data-id="element-38">
        ✨ Free Astrology Reading on WhatsApp{' '}
        <span aria-hidden="true" data-id="element-39">&rarr;</span>
      </Link>
      <button onClick={handleDismiss} className="absolute right-4 text-beige-muted hover:text-white transition-colors" aria-label="Dismiss announcement" data-id="element-40">
        <X className="w-4 h-4" data-id="element-41" />
      </button>
    </div>;
}